import { loader } from 'graphql.macro'

export default async function addCostToTicketSite ({ dataLoaders, variables }) {
  const schema = loader('./addCostToTicketSite.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.addCostToTicketSite
}
